import authService from './authService';

let BASE_URL = process.env.REACT_APP_API_URL;

async function loadConfig() {
  try {
    const response = await fetch("/config.json");
    const config = await response.json();
    BASE_URL = config.API_URL || BASE_URL;
  } catch (error) {
    console.error("Failed to load config.json. Using default .env API URL", error);
  }
}

loadConfig().then(() => {});

export async function fetchAllDataApi(url: string, options: RequestInit = {}): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/${url}`, { ...options });
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error(data.message || "Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to fetch");
  }
}

export async function getLatestMessages(url: string, options: RequestInit = {}): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/${url}`, { ...options });
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error(data.message || "Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to fetch");
  }
}

export type NotificationListFilters = {
  type?: string;
  startDate?: string;
  endDate?: string;
};

export async function fetchAllNotifications(
  perPage: number,
  pageNo: number,
  search: string,
  filters?: NotificationListFilters
): Promise<any> {
  try {
    const params = new URLSearchParams();
    params.set('search', search ?? '');
    params.set('perPage', String(perPage));
    params.set('pageNo', String(pageNo));
    if (filters?.type) params.set('type', filters.type);
    if (filters?.startDate) params.set('startDate', filters.startDate);
    if (filters?.endDate) params.set('endDate', filters.endDate);
    const response = await authService.apiCall(
      `${BASE_URL}/notifications/user-notifications?${params.toString()}`,
      { method: 'GET' }
    );
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error(data.message || "Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to fetch");
  }
}

export async function getUnseenNotifications(userId: string): Promise<any> {
  try {
    if (!BASE_URL) {
      return { success: false, totalCount: 0 };
    }
    const response = await authService.apiCall(
      `${BASE_URL}/notifications/unseen?userId=${userId}`,
      { method: 'GET' }
    );
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error(data.message || "Failed to fetch unseen notifications");
    }
    return data;
  } catch (error: any) {
    const msg = error?.message ?? String(error);
    if (msg.includes("Forbidden")) {
      throw error;
    }
    // Network / CORS / offline — do not surface as uncaught runtime error; badge shows 0
    console.warn("[notifications] unseen:", msg);
    return { success: false, totalCount: 0 };
  }
}

export async function seenNotification(userId: string): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/notifications/seen`, {
      method: 'PATCH',
      body: JSON.stringify({ userId }),
    });
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error(data.message || "Failed to mark notifications as seen");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to mark notifications as seen");
  }
}
